import { render, staticRenderFns } from "./PanelBookingPrice.vue?vue&type=template&id=5fea5d75&scoped=true"
import script from "./PanelBookingPrice.vue?vue&type=script&lang=js"
export * from "./PanelBookingPrice.vue?vue&type=script&lang=js"
import style0 from "./PanelBookingPrice.vue?vue&type=style&index=0&id=5fea5d75&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fea5d75",
  null
  
)

export default component.exports